import {interactiveImage} from "@/class/interactive-image/interactiveImage";
import {panorama} from "@/class/panorama/panorama";
import {contentPage} from "@/class/content-page/contentPage";
import {story} from "@/class/story";
import {annotation} from "@/class/annotation/annotation";
import {video} from "@/class/video/video";
import {area} from "@/class/interactive-image/area";
import {hotspot} from "@/class/interactive-image/hotspot";
import {overlay} from "@/class/interactive-image/overlay";
import {text} from "@/class/interactive-image/text";
import {xrayspot} from "@/class/interactive-image/xrayspot";
import {marker} from "@/class/interactive-image/marker";
import chapter from "@/class/interactive-image/chapter";
import {map} from "@/class/map/map";
import {stories} from "@/class/stories";

const state = {
    globalInfo : {
        "interactive_image" : {
            label : "Interactive image",
            icon :"fa-images",
            route : "interactive-image",
            color: "#378EF0",
            class: interactiveImage,
            canLink:true,
            canCreate:true,
            canEdit:true,
        },
        "interactive-chapter" : {
            label : "Interactive image Chapter",
            icon :"fa-image-polaroid",
            route : "interactive-chapter",
            color: "#378EF0",
            class: chapter,
            canLink:false,
            canCreate:true,
            canEdit:true,
        },
        "map" : {
            label : "Map",
            icon :"fa-map",
            route : "map",
            color: "#1da300",
            class: map,
            canLink:true,
        },
        "panorama" : {
            label : "Panorama",
            icon :"fa-globe",
            route : "panorama",
            color: "#e74c3c",
            class: panorama,
            canLink:true,
        },
        "content_page" : {
            label : "Article",
            icon :"fa-file-alt",
            route : "content-page",
            color: "#de80ff",
            class: contentPage,
            canLink:true,
        },
        "stories" : {
            label : "All Stories",
            icon :"fa-book",
            route : "story",
            color: "#e67e22",
            class: stories,
            canLink:false,
        },
        "story" : {
            label : "Story",
            icon :"fa-book",
            route : "story",
            color: "#00a183",
            class: story,
            canLink:false,
        },
        "all" : {
            label : "All",
            icon :"fa-border-all",
            color: "#3472ff",
            canLink:false,
        },
        "annotation": {
            label : "Annotations",
            icon : "fa-comment-lines",
            route : "annotation",
            color: "#9e8300",
            class: annotation,
            canLink:true,
            canEdit:true,
        },
        "video": {
            label : "Video",
            icon : "fa-video",
            route : "video",
            color: "#8d008d",
            class: video,
            canLink:true,
            linkName:"linked_video",
            canCreate:true,
            canEdit:true,
        }
    },
    labelInfo: {
        "interactive_image": {
            "area": {
                label: "Areas",
                icon: "fa-vector-square",
                route : "interactive-area",
                class: area
            },
            "hotspot": {
                label: "Hotposts",
                icon: "fa-dot-circle",
                route : "interactive-hotspot",
                class: hotspot
            },
            "marker": {
                label: "Markers",
                icon: "fa-map-marker",
                route : "interactive-marker",
                class: marker
            },
            "overlay": {
                label: "Overlays",
                icon: "fa-images",
                route : "interactive-overlay",
                class: overlay
            },
            "text": {
                label: "Texts",
                icon:"fa-text",
                route : "interactive-text",
                class: text
            },
            "xrayspot":  {
                label: "XRays",
                icon: "fa-circle",
                route : "interactive-xrayspot",
                class: xrayspot
            },
        }
    },
}

const getters = {
    // object lsit
    type: state => type => {
        return state.globalInfo[type];
    },
    iconByType: state => type => {
        return state.globalInfo[type].icon;
    },
    labelByType: state => type => {
        return state.globalInfo[type].label;
    },
    routeByType: state => type => {
        return state.globalInfo[type].route;
    },
    colorByType: state => type => {
        return state.globalInfo[type].color;
    },
    getObjectTypesLink : state => {
        let types = []
        for (const [key, value] of Object.entries(state.globalInfo)) {
            if(!value.canLink) continue;
            types.push(key);
        }
        return types;
    },
    getGlobalInfoLink : state => {
        
        let types = []
        for (const [key, value] of Object.entries(state.globalInfo)) {
            if(!value.canLink) continue;
            types.push({...value,type:key});
        }
        return types;
    },
    
    // labels lists
    labels: state => type => {
        let labels = [];
        for (const [key, value] of Object.entries(state.labelInfo[type])) {
            labels.push({...value, type:key});
        }
        return labels;
    },
    label: state => (type,label) => {
        return {...state.labelInfo[type][label], type:label};
    },
    
};

const actions = {

};

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}
